import React from "react";

import styles from "./style.module.css";

export default class RightPanel extends React.PureComponent {
  render() {
    const { title, isOpen, children } = this.props;
    return (
      <div className={styles.rightPanelWrapper + " " + (isOpen ? "" : styles.hide)}>
        <div className={styles.rightPanelHeader}>{title}</div>
        <div className={styles.rightPanelBody}>{children}</div>
      </div>
    );
  }
}
